module.exports = __webpack_public_path__ + "static/media/dks50.e0a8e322.png";